import { render, staticRenderFns } from "./page-account.vue?vue&type=template&id=ef505768&scoped=true"
import script from "./page-account.vue?vue&type=script&lang=js"
export * from "./page-account.vue?vue&type=script&lang=js"
import style0 from "./page-account.vue?vue&type=style&index=0&id=ef505768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef505768",
  null
  
)

export default component.exports